module.exports = __webpack_public_path__ + "assets/img/phone3.19d2bf83.png";